import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import TagManager from 'react-gtm-module';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Main from './Main';
import TermsPage from './terms/TermsPage';

const tagManagerArgs = { gtmId: 'GTM-KJBNN36' };

type AppProps = {
  isLoggedIn: () => boolean;
};

let mainPath = '/';

if (process.env.NODE_ENV === 'production') {
  mainPath = '/xtramotion/trial';
}

const App = (props: AppProps) => {
  const [cookies, setCookie] = useCookies(['cookies_accepted_categories']);

  useEffect(() => {
    // console.log(cookies);

    if ('cookies_accepted_categories' in cookies && cookies.cookies_accepted_categories.includes('google_analytics')) {
      if (process.env.REACT_APP_ENV === 'production') {
        TagManager.initialize(tagManagerArgs);
      }
    }
  }, [cookies]);

  function learnMoreOnClick() {
    window.open(
      'https://evs.com/products/live-replays-storytelling/xtramotion?utm_source=XtraMotion+trial&utm_medium=referral&utm_campaign=XtraMotion+self+trial',
      '_blank',
    );
  }

  function shareOnClick() {
    TagManager.dataLayer({ dataLayer: { event: 'share' } });

    window.open(
      `mailto:?subject=Share%20the%20XtraMotion%20experience%20by%20EVS&body=${process.env.REACT_APP_SITE}/xtramotion/trial`,
      '_blank',
    );
  }

  function contactOnClick() {
    TagManager.dataLayer({ dataLayer: { event: 'contact_us' } });
    window.open(
      'https://evs.com/your-question-about-xtramotion?utm_source=XtraMotion+trial&utm_medium=referral&utm_campaign=XtraMotion+self+trial',
      '_blank',
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={mainPath}
          element={
            <Main
              learnOnClick={() => learnMoreOnClick()}
              contactOnClick={() => contactOnClick()}
              shareOnClick={() => shareOnClick()}
              isLoggedIn={props.isLoggedIn}
            />
          }
        />
        {/* <Route path="/terms" element={<TermsPage />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
